<template>
  <div class="luxury-new-report-wrapper">
    <div v-if="isFrom === 'micro'" class="popup-common-title">
      <span class="tt">{{ '验机报告' }}</span>
      <z-icon
        v-zpm="{
          sectionid: 189,
          sortid: 0,
          sortname: '关闭按钮',
        }"
        name="cross"
        class="pop-close"
        @click="close"
      />
    </div>

    <section class="qc-report">
      <div class="report-wrap">
        <!-- 鉴定评估报告模块 -->
        <div
          v-if="isGoodsDetail"
          class="flowerBg"
          :style="{
            backgroundImage: `url(${setPicSize(
              'https://pic2.zhuanstatic.com/zhuanzh/d4b90dc7-354d-4584-98dd-19fc17c6c134.png',
              686
            )})`,
          }"
        >
          <div class="reportIntro" @click.stop="enterReportTntro">
            <p class="leftText">可能是全网唯一“真的官方验”的二手质检中心</p>
            <div class="rightSec">
              <span class="rightDesc1">查看鉴定中心</span>
              <img
                src="https://pic3.zhuanstatic.com/zhuanzh/6742dc86-7196-4cfb-ab51-42158307ff6c.png"
                class="rightArrow"
              />
            </div>
          </div>
          <h1 class="reportTitle">鉴定评估报告</h1>
        </div>

        <!-- 鉴定报告内容部分 -->
        <!-- 底纹平铺 -->
        <div class="wrapContentBg">
          <div class="wrapContent" :class="{ 'wrapContent-mainDetail': isGoodsDetail }">
            <div v-if="isGoodsDetail">
              <div class="wrapContent-title">
                {{ dataInfo.title || ' ' }}
              </div>

              <div
                v-if="reportData && reportData.qcCode && reportData.qcCode.length > 0"
                class="wrapContent-No"
              >
                <span>鉴定编号：{{ reportData.qcCode }}</span>
                <img
                  v-clipboard:copy="reportData.qcCode"
                  v-clipboard:success="copyNo"
                  class="wrapContent-No-copyIcon"
                  :src="
                    setPicSize(
                      'https://pic3.zhuanstatic.com/zhuanzh/486f4289-337d-4810-a356-5634d9937301.png'
                    )
                  "
                  @click.stop="copyNo"
                />
              </div>

              <div v-else class="wrapContent-placeholder"></div>

              <div class="wrapContent-portraitArea">
                <div class="wrapContent-portraitArea-personInfo" @click.stop="openQcUserDetail">
                  <img :src="qcUser.icon" class="wrapContent-portraitArea-personInfo-portrait" />
                  <div class="personInfoBg">
                    <div class="personInfoWrapper">
                      <p class="wrapContent-portraitArea-personInfo-name">
                        鉴定师 {{ qcUser.name }}
                      </p>
                      <z-icon
                        v-if="dataInfo.detailType !== 'pop'"
                        class-prefix="zziconfont-6"
                        name="arrow"
                        color="#999999"
                        size="8px"
                      />
                    </div>
                    <p
                      v-if="qcUser && qcUser.qcUserId"
                      class="wrapContent-portraitArea-personInfo-desc"
                    >
                      员工编号:{{ qcUser && qcUser.qcUserId }}
                    </p>
                  </div>
                </div>
              </div>
              <img
                class="wrapContent-appraiseComplete"
                :src="
                  setPicSize(
                    'https://pic2.zhuanstatic.com/zhuanzh/c9dce580-1f2c-4758-99cf-6d4d10a25321.png'
                  )
                "
              />
            </div>

            <BaseInfo
              :dataInfo="dataInfo"
              :qualityInfo="dataInfo"
              :config="dataInfo.luxuryReport"
              @toggle="toggleConditionPopup"
              @openPopupWarchPedia="openPopupWarchPedia"
            ></BaseInfo>
            <!-- 质检项区域 -->
            <QcReport
              v-if="reportData && reportData.reportItem"
              :picList="pics"
              :dataInfo="dataInfo"
              @toggle="showItem"
            ></QcReport>
            <!-- 二奢商详 是 detailType === 'normal'  === infoType != 1000 && infoType != 2 
              dataInfo.infoType 会有空值情况 兼容omsSkuId场景
            -->
            <ImgModule
              :dataInfo="dataInfo"
              :infoId="infoId"
              :config="dataInfo.luxuryReport"
              :warehouseInfo="warehouseInfo"
            ></ImgModule>
            <!-- 转转通场景不展示反馈逻辑 -->
            <ReportFeedback v-if="!iszzT" :dataInfo="dataInfo" :infoId="infoId"></ReportFeedback>
          </div>
          <ReportFootNote :reportData="reportData"></ReportFootNote>
        </div>
      </div>
      <!-- 等级说明弹框 -->
      <RankDescription
        v-if="isNewRankPopup"
        ref="rankDescription"
        brandUpgrade
        :infoId="infoId"
        :cateId="Number(cateId) || Number(lxuCateId)"
        :channelId="1"
        :qualityRatingModule="qualityRatingModule"
        :showFeedback="true"
        :feedbackData="feedbackData"
      ></RankDescription>

      <!-- 二奢老版成色弹窗 -->
      <BottomDialog v-else ref="panel" title="说明">
        <div class="panel-content">
          <div class="box">
            <div class="title">新品</div>
            <div class="content">首次出售 非二手商品</div>
          </div>
          <div class="tip">二手成色评级标准</div>
          <div v-for="(item, index) in finenessInfo" :key="index" class="box">
            <div class="title">
              <!-- <span class="num">{{ item.num }}</span> -->
              <span class="text">{{ item.conditionName }}</span>
            </div>
            <div class="content">{{ item.conditionText }}</div>
          </div>
        </div>
      </BottomDialog>
    </section>
  </div>
</template>

<script lang="js">
  import Vue from 'vue'
  import native from '@zz-common/native-adapter'
  import BaseInfo from './BaseInfo'
  import QcReport from './QcReport'
  import ReportFeedback from './ReportFeedback'
  import ReportFootNote from './ReportFootNote'
  import ImgModule from './ImgModule'
  import RankDescription from '../../rank-description'
  import BottomDialog from './bottomDialog'
  import VueClipboard from 'vue-clipboard2'
  import { getOrderDetail } from '../../apis/index'
  import { Icon, FixTop } from '@zz-common/zz-ui'
  import { setPicSize } from '@zz-common/zz-utils'
  import { getQueryString } from '../../utils'

  Vue.use(Icon).use(FixTop).use(VueClipboard)

  export default {
    name: 'zz-luxury-quality-report',
    components: {
      BaseInfo,
      QcReport,
      ReportFeedback,
      ReportFootNote,
      ImgModule,
      BottomDialog,
      RankDescription
    },
    props: {
      picList: {
        type: Array,
        default: () => []
      },
      luxuryReportData: {
        type: Object,
        default: () => {}
      },
      goodsInfo: {
        type: Object,
        default: () => {}
      },
      feedbackData: {
        type: Object,
        default: () => ({})
      },
      // 传入infoId和cateId 埋点使用
      infoId: {
        type: String,
        default: ''
      },
      cateId: {
        type: String,
        default: ''
      },
      // 兼容转转通场景
      omsSkuId: {
        type: String,
        default: ''
      },
      warehouseInfo: {
        type: String,
        default: ''
      },
      isGoodsDetail: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        dataInfo: {},
        // infoId: getQueryString('infoId') || state.infoId,
        lxuCateId: '',
        isFrom: '',
        setPicSize,
      }
    },
    computed: {
      qcUser() {
        return this.reportData?.qcUser || {}
      },
      iszzT(){
        return native.in('zztong')
      },
      finenessInfo() {
        return this.dataInfo?.conditionIntro?.data || {}
      },

      pics() {
        if(this.isGoodsDetail){
          return this.picList
        }
        return this.dataInfo.pics
      },
      reportData(){
        return this.dataInfo.luxuryReport
      },
      qualityRatingModule() {
        return this.dataInfo.conditionIntro || {}
      },
      isNewRankPopup() {
        const { finenessLevelValueId, finenessDialogContents } = this.qualityRatingModule
        if(!finenessLevelValueId) return false
        return !!(finenessDialogContents || []).find(
          ({ valueId }) => valueId === finenessLevelValueId
        )
      }
    },
    created() {
      this.getOrderSnapshot()
      this.isFrom = getQueryString('from')
      this.iszzT &&  native.setTitle({
        title:'质检报告'
      })
    },

    methods: {
      // 获取质检报告数据
      async getOrderSnapshot(){
        if(!this.isGoodsDetail){
          // 不是商详的页面 调用订单快照接口
          const {data} = await getOrderDetail({
          infoId: this.infoId,
          omsSkuId: this.omsSkuId
        })
        this.dataInfo = {
          ...data,
            report: data.luxuryReport
          }
          this.lxuCateId = data.cateFirstId
        }
        console.log('数据：', this.dataInfo);
      },
       close () {
          window.parent.postMessage('close', '*')
          native.close()
    },
      copyNo() {
        this.$toast('复制成功')
      },
      // toggleCondition() {
      //   // this.$refs.qualityRef.toggleConditionPopup()
      //   // this.$refs.panel.show()
      // },
      showItem(data) {
        this.$refs.itemPop.togglePopup(data)
      },
      enterReportTntro() {
        native.skipToUrl({
          targetUrl:
            'https://m.zhuanzhuan.com/platform/quality_inspection_live/index.html?needHideHead=3&businessTabId=2#/home'
        })
      },
      openQcUserDetail() {
        const _url = `https://act.zhuanzhuan.com/platform/zz-platform-pages/check/appraiser-card?wvCornerRadius=32&wvHalfVer=v2&wvHeightRate=0.5&needHideHead=3&data=${encodeURIComponent(
          JSON.stringify(this?.reportData?.reporterModel)
        )}`
        native.skipToUrl({
          targetUrl: _url
        })
      },
      /**
       * $ 二奢参数规格点击事件
       */
      // 二奢融合
      openPopupWarchPedia(checkId) {
        this.$emit('openPopupWarchPedia', checkId)
      },
      toggleConditionPopup() {
        // 转转通场景不允许弹出
        if (this.iszzT) return
        if (this.isNewRankPopup) {
          this.$refs.rankDescription.togglePopup()
        } else {
          this.$refs.panel.show()
        }
      }
    },
    watch: {
      goodsInfo: {
        handler(val){
          // 商详数据赋值
          if(val && Object.keys(val).length > 0 && this.isGoodsDetail){
            this.dataInfo = {
            ...this.goodsInfo,
            conditionIntro: this.goodsInfo?.report?.conditionIntro,
            report: this.goodsInfo.luxuryReport
          }
          }
        },
        immediate: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@zz-common/zz-ui/lib/style/mixins/hairline.scss';
  @import '@zz-common/zz-ui/lib/style/mixins/ellipsis.scss';

  .luxury-new-report-wrapper {
    min-height: 500px;
    overflow: hidden;

    .popup-common-title {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 10;
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      width: 100%;
      height: 104px;
      padding: 0 24px;
      padding-top: 24px;
      color: #111111;
      font-weight: 500;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      background-color: #fff;

      .pop-close {
        position: absolute;
        top: 44px;
        right: 32px;
        width: 50px;
        color: #999999;
        text-align: right;
      }
    }

    .qc-report {
      padding: 64px 32px 32px;
      font-size: 24px;
      line-height: 1;
      background: #ffffff;
    }

    &.qc-report-0 {
      padding: 0;

      .qc-report {
        padding: 0;
      }

      .report-wrap {
        padding-top: 20px !important;
      }
    }

    .report-wrap {
      position: relative;
      padding-bottom: 20px;
      border-radius: 0 0 24px 24px;
      .flowerBg {
        position: relative;
        box-sizing: border-box;
        width: 686px;
        height: 140px;
        background: center / cover no-repeat;
        border: 1px solid transparent;
        .reportTitle {
          position: relative;
          z-index: 1;
          margin: 40px 0 0 30px;
          color: #111111;
          font-weight: 600;
          font-size: 54px;
          font-family: PingFangSC-Semibold, PingFang SC;
        }
        .reportIntro {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 622px;
          margin: 40px auto 0;
          line-height: 1;
          .leftText {
            color: #111111;
            font-weight: 300;
            font-size: 20px;
            font-family: PingFangSC-Light, PingFang SC;
          }
          .rightSec {
            display: flex;
            align-items: center;
            .rightDesc1 {
              color: #111111;
              font-weight: 300;
              font-size: 20px;
              font-family: PingFangSC-Light, PingFang SC;
            }
            .rightArrow {
              width: 10px;
              height: 18px;
              margin: 0 0 0 6px;
              background: center / cover no-repeat;
            }
          }
        }
      }
      .wrapContentBg {
        position: relative;
        top: -2px;
        box-sizing: border-box;
        width: 686px;
        min-height: 400px;
        background: url('https://pic5.zhuanstatic.com/zhuanzh/647dfb79-0c5e-41b2-96a7-b77ec0b02a2d.png')
          top / contain repeat-y;
        border: 1px solid transparent;
        border-radius: 0 0 20px 20px;
        .wrapContent {
          position: relative;
          box-sizing: border-box;
          width: 662px;
          margin: 16px auto 0;
          background-color: #ffffff;
          border: 1px solid transparent;
          border-radius: 8px;
          &-No {
            display: flex;
            align-items: center;
            margin: 16px 0 16px 32px;
            color: #999999;
            font-weight: 300;
            font-size: 20px;
            font-family: PingFangSC-Light, PingFang SC;
            &-copyIcon {
              width: 20px;
              height: 20px;
              margin: 0 0 0 8px;
              object-fit: cover;
            }
          }

          &-placeholder {
            height: 32px;
          }

          &-title {
            @include multi-ellipsis(2);
            width: 396px;
            margin: 36px 0 0 32px;
            color: #111111;
            font-weight: 400;
            font-size: 26px;
            font-family: PingFangSC-Regular, PingFang SC;
            line-height: 38px;
          }
          &-portraitArea {
            position: absolute;
            top: -18px;
            right: 20px;
            display: flex;
            justify-content: center;
            box-sizing: border-box;
            width: 190px;
            height: 232px;
            background: url('https://pic4.zhuanstatic.com/zhuanzh/c40f422c-14fa-48f5-a4ff-514e262652e2.png')
              center / cover no-repeat;

            &-personInfo {
              z-index: 1;
              display: flex;
              flex-direction: column;
              align-items: center;
              box-sizing: border-box;
              width: 182px;
              margin: -12px auto 0;

              .personInfoBg {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                box-sizing: border-box;
                width: 180px;
                width: 180px;
                height: 80px;
              }
              .personInfoWrapper {
                display: flex;
                align-items: center;
                height: 18px;
              }
              &-portrait {
                box-sizing: border-box;
                width: 156px;
                height: 156px;
                margin: 12px 0 0;
                object-fit: cover;
              }
              &-name {
                color: #999999;
                font-weight: 300;
                font-size: 18px;
                font-family: PingFangSC-Light, PingFang SC;
                line-height: 1;
              }
              &-desc {
                @include multi-ellipsis(1);
                margin: 8px 0 0;
                color: #999999;
                font-weight: 300;
                font-size: 18px;
                font-family: PingFangSC-Light, PingFang SC;
                line-height: 1;
              }
            }
          }
          &-appraiseComplete {
            position: absolute;
            top: 93px;
            right: 179px;
            width: 126px;
            height: 126px;
            object-fit: contain;
            rotate: -8deg;
          }
        }
        .wrapContent-mainDetail {
          margin: 56px auto 0;
        }
      }
    }
  }

  .panel-content {
    padding: 0 40px 40px;
    color: #666666;
    font-weight: 400;
    font-size: 26px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    line-height: 26px;

    .tip {
      margin: 36px 0 24px;
    }

    .box {
      display: flex;
      justify-content: space-between;
      margin-bottom: 4px;

      .title {
        width: 140px;
        height: 88px;
        color: #111111;
        font-weight: 500;
        font-size: 26px;
        font-family: Akrobat-ExtraBold;
        line-height: 88px;
        text-align: center;
        background: #f8f8f8;

        .num {
          font-size: 30px;
        }
      }

      .content {
        width: 526px;
        height: 88px;
        margin-left: 4px;
        padding: 0 40px;
        line-height: 88px;
        background: #f8f8f8;
      }
    }

    .box:nth-child(1) {
      .title {
        border-radius: 12px 0 0 12px;
      }

      .content {
        border-radius: 0 12px 12px;
      }
    }

    .box:nth-child(3) {
      .title {
        border-radius: 12px 0 0;
      }

      .content {
        border-radius: 0 12px 0 0;
      }
    }

    .box:last-child {
      .title {
        border-radius: 0 0 0 12px;
      }

      .content {
        border-radius: 0 0 12px;
      }
    }
  }

  .panel-content {
    font-size: 26px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #666666;
    line-height: 26px;
    padding: 0 40px 40px;

    .tip {
      margin: 36px 0 24px;
    }

    .box {
      display: flex;
      justify-content: space-between;
      margin-bottom: 4px;

      .title {
        width: 140px;
        height: 88px;
        background: #f8f8f8;
        line-height: 88px;
        text-align: center;
        font-size: 26px;
        font-family: Akrobat-ExtraBold;
        font-weight: 500;
        color: #111111;

        .num {
          font-size: 30px;
        }
      }

      .content {
        width: 526px;
        height: 88px;
        background: #f8f8f8;
        line-height: 88px;
        padding: 0 40px;
        margin-left: 4px;
      }
    }

    .box:nth-child(1) {
      .title {
        border-radius: 12px 0 0 12px;
      }

      .content {
        border-radius: 0 12px 12px;
      }
    }

    .box:nth-child(3) {
      .title {
        border-radius: 12px 0 0;
      }

      .content {
        border-radius: 0 12px 0 0;
      }
    }

    .box:last-child {
      .title {
        border-radius: 0 0 0 12px;
      }

      .content {
        border-radius: 0 0 12px;
      }
    }
  }
</style>
